// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"25a87ed4","42":"fcbffc40","232":"1963ee9e","274":"8921f48b","276":"f5e0ed61","474":"d6a5f106","564":"bf9c7a42","731":"c0f0396e","756":"23396ddc","817":"8964ef14","871":"21221359","908":"1d27638b","991":"6572c15c","994":"049f291b"}[chunkId] + ".chunk.js";
};